import React from "react";
import "./Common_Btn.css";

const Common_Btn = ({ text, onClick, type = "type" }) => {
    return (
        <button className="common_btn" type={type} onClick={onClick}>
            {text}
        </button>
    );
};

export default Common_Btn;
